// ─── Enums ────────────────────────────────────────────────────────────────────

export enum InvoiceStatus {
  UNPAID = "UNPAID",
  PARTIAL_PAID = "PARTIAL_PAID",
  PAID = "PAID",
  OVERPAID = "OVERPAID"
}
